// extracted by mini-css-extract-plugin
module.exports = {"tableWrapper":"Table_tableWrapper__2o4YU","col":"Table_col__2_-3d","fulfillmentStatus":"Table_fulfillmentStatus__1fPlF","emailCol":"Table_emailCol__3Ypt8"};